import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import PageBuilder from "@/pages/PageBuilder";
import PageAnalytics from "@/pages/PageAnalytics";
import PagePreview from "@/pages/PagePreview";
import PageShare from "@/pages/PageShare";
import PublicFanPage from "@/pages/PublicFanPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/s/:slug" element={<PublicFanPage />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/builder/:id" element={<ProtectedRoute><PageBuilder /></ProtectedRoute>} />
            <Route path="/pages/:id/analytics" element={<ProtectedRoute><PageAnalytics /></ProtectedRoute>} />
            <Route path="/preview/:id" element={<ProtectedRoute><PagePreview /></ProtectedRoute>} />
            <Route path="/pages/:id/share" element={<ProtectedRoute><PageShare /></ProtectedRoute>} />
            <Route path="/:handle/:slug" element={<PublicFanPage />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
